import Ad from "../../../../../Ad/component";
import "./styles/themes/_default.scss";

const ShowMoreAd = ({ type }) => {
    return (
        <div className="show-more-ad">
            <Ad type={type} lazy targeting={{ plc: "more" }} />
        </div>
    );
};

export default ShowMoreAd;
